<template>
  <div>
    <EbHeader>
      <EbBreakCrumb slot="breakCrumb" />
    </EbHeader>
    <el-row>
      <el-col :span="24">
        <router-link to="/projpro/new/info">
          <div class="grid-content">询价</div>
        </router-link>
        <router-link to="/projbid/new/info">
          <div class="grid-content">招标</div>
        </router-link>
        <router-link to="/projnew/new/info">
          <div class="grid-content">竞价</div>
        </router-link>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import EbHeader from '@/components/common/eb-header';
import EbBreakCrumb from '@/components/common/eb-break-crumb';

export default {
  components: {
    EbHeader,
    EbBreakCrumb
  }
};
</script>

<style>
.grid-content {
  height: 80px;
  width: 80px;
  background: #cccccc;
  float: left;
  margin: 15px 15px;
  text-align: center;
  line-height: 80px;
  border-radius: 8px;
}
.grid-content:hover {
  background: #fb5b3b;
}
</style>
